import React from 'react';
import moment from 'dayjs';

import { ChartRangeOptionT, InstrumentPriceBarT, ChartRange } from 'types';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

import './ChartTab.scss';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Filler, Legend);

type Params = {
  selectedRange: ChartRangeOptionT;
  instrumentPriceBars: InstrumentPriceBarT[];
  isLoading: boolean;
};

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  aspectRatio: 1 | 1,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      displayColors: false,
    },
  },
  scales: {
    y: {
      type: 'linear' as const,
      display: true,
      position: 'right' as const,
    },
  },
};

const ChartTab = ({ selectedRange, instrumentPriceBars, isLoading }: Params) => {
  const getLabels = instrumentPriceBars.map(bar => {
    const barDate = new Date(bar.ts);

    if (selectedRange.id === ChartRange.Day) {
      return moment(barDate).format('HH:mm');
    }

    return moment(barDate).format('MM/DD');
  });

  const data = {
    labels: getLabels,
    datasets: [
      {
        fill: true,
        label: 'Price',
        data: instrumentPriceBars.map(i => i.close),
        borderWidth: 2,
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
      },
    ],
  };

  return (
    <div className="chart-container">
      <Line options={options} data={data} />
    </div>
  );
};

export default React.memo(ChartTab);
